import React, { useState } from "react";

import Signup from "./Signup";
import Login from "./Login";

const Home = () => {
  const [signupVisible, setSignupVisible] = useState(true);

  return (
    <div className="home">
      {signupVisible && <Signup />}

      {!signupVisible && <Login />}
    </div>
  );
};

export default Home;
